import { LogisticalDeclarationExcelData } from '../../../types'
import { Row } from './types'
import { addRowStyles, borderThin, COLOR } from './utils'

export function getRowShipment(data: LogisticalDeclarationExcelData[]) {
    const backgroundColor = COLOR.blue
    const row: Row[] = [
        {
            align: 'center',
            value: 'TIPO DE EMBARQUE',
            width: 80,
            fontWeight: 'bold',
            backgroundColor: backgroundColor
        }
    ]
    data.forEach(d => {
        row.push({
            value: '',
            backgroundColor: backgroundColor
        })
        row.push({
            value: '',
            backgroundColor: backgroundColor
        })
        row.push({
            value: '',
            backgroundColor: backgroundColor
        })
        row.push({
            align: 'center',
            fontWeight: 'bold',
            value: d.type_shipment.name.toUpperCase(),
            backgroundColor: backgroundColor
        })
        row.push({
            value: '',
            backgroundColor: COLOR.gray
        })
    })
    return addRowStyles(row, [borderThin])
}
